import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=217f9e16&scoped=true"
import script from "./Doctor.vue?vue&type=script&lang=js"
export * from "./Doctor.vue?vue&type=script&lang=js"
import style0 from "./Doctor.vue?vue&type=style&index=0&id=217f9e16&prod&scoped=true&lang=css"
import style1 from "./Doctor.vue?vue&type=style&index=1&id=217f9e16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f9e16",
  null
  
)

export default component.exports